import { IRecognizedBody, IRecognizedBodyParams } from '@app-types/recognizedBody';
import axios from './axios';

const getOne = (id: string) => axios.get<IRecognizedBody>(`/recognized-bodies/${id}`);

const getAll = (params: IRecognizedBodyParams) => axios.get<IRecognizedBody[]>('/recognized-bodies/all', { params });

export default { getOne, getAll };
